/* eslint-disable */
export const options = [
    { value: 'ALL', label: 'All' },
    { value: 'MOBILE', label: 'Mobile' },
    { value: 'DESKTOP', label: 'Desktop' },
    { value: 'TABLET', label: 'Tablet' },
    { value: 'NONE', label: "Don't get search data" },
];
